import { permissions } from "./permissionReducer";

export default permissions;